import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ViewerAssetPage } from './viewer-asset';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    ViewerAssetPage,
  ],
  imports: [
    IonicPageModule.forChild(ViewerAssetPage),
    ComponentsModule
  ],
  exports: [
    ViewerAssetPage
  ]
})
export class ViewerAssetPageModule {}



// WEBPACK FOOTER //
// ./src/pages/viewer-asset/viewer-asset.module.ts